module.exports = __webpack_public_path__ + "img/line-purple-top.913012d8.png";